export const MENU_PARAMS = [
  { title: 'menu.language', path: '/menu/language', icon: 'language' },
  // { title: 'menu.ton_wallet', path: '/menu/ton-wallet', icon: 'wallet' },
  { title: 'menu.support', path: '/menu/support', icon: 'support-small' },
  { title: 'menu.history_of_transaction', path: '/transactions', icon: 'history-of-transaction' },
  // { title: 'menu.exit', path: '/menu/logout', icon: 'logout-small' },
  // { title: 'menu.delete_data', path: '/menu/data-deletion', icon: 'bin' },
  // { title: 'menu.enter_promo_code', path: '/menu/promo', icon: 'gift' },
]
